import state from "./state";

export default {
  SET_UPDATE_SPEAKER(state, payload) {
    state.dataForUpdateSpeaker = payload;
  },
};
